import React from 'react';
import Styles from '../../../../../stylesheet/css/header-builder/icons/tablet.css';
import stylesDevice from '../../../../../stylesheet/css/header-builder/devices-link.css';

const Tablet = (props) => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="18px" height="20px" viewBox="0 0 18 20" xmlSpace="preserve" fill="#a6a6a6">
    <path className={`st0 ${stylesDevice.svgPath}`} d="M16,0H2C0.9,0,0,0.9,0,2v16c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V2C18,0.9,17.1,0,16,0z M10.2,17.4 c-0.5,0.7-1.4,0.8-2.1,0.3c-0.7-0.5-0.8-1.4-0.3-2.1c0.5-0.7,1.4-0.8,2.1-0.3C10.5,15.8,10.7,16.7,10.2,17.4z"/>
  </svg>
);

export default Tablet;


// WEBPACK FOOTER //
// ./app/header-builder/components/icons/Tablet.js